<template>
  <ol class="breadcrumb">
    <li class="breadcrumb-item" :key="index" v-for="(item, index) in list">
      <span class="active" v-if="isLast(index)">{{ customBreadcrumbName || showName(item) }}</span>
      <router-link :to="item" v-else>{{ showName(item) }}</router-link>
    </li>
  </ol>
</template>

<script>

import { EventBus } from "../views/event-bus";
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      customBreadcrumbName: ''
    }
  },
  methods: {
    isLast (index) {
      return index === this.list.length - 1
    },
    showName (item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label
      }
      if (item.name) {
        item = item.name
      }
      return item
    },
  },
  created() {
    //마지막 메뉴명 변경을 위한 이벤트 버스
    EventBus.$on('change-last-breadcrumb-name', (newName) => {
      this.customBreadcrumbName = newName;
    });

    EventBus.$on('reset-last-breadcrumb-name', () => {
      this.customBreadcrumbName = '';
    });

  },
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue